import {onBlockLoaded} from "@plaudit/frontend-apis";

onBlockLoaded({
	blockOrClassName: "msa-request-a-quote/submit-quote-request",
	onAdd(blockRoot) {
		// blockRoot is the root element of the block (aka the element that has the wp-block-msa-request-a-quote/submit-quote-request class on it)
		// You can add any logic that needs to run once per block here
		updateCount(blockRoot);

		document.addEventListener("msa/region-locked-products/quote-update", () => updateCount(blockRoot));
		document.addEventListener('visibilitychange', () => updateCount(blockRoot));
	}
	// If you need to add logic that runs once per removal, add onRemove(blockRoot) {} to this object
});

function updateCount(blockRoot: HTMLElement) {
	const products = JSON.parse(localStorage.getItem("msa/request-a-quote/products") ?? '{}') as Record<string, number>;
	const quantity = Object.values(products).reduce((a, b) => a + b, 0).toString();
	const counter = blockRoot.querySelector(".counter");
	if (counter) {
		counter.setAttribute("data-count", quantity);
		counter.innerHTML = quantity;
	}
}
